module.exports = __webpack_public_path__ + "img/login_left_back.png";